import React from 'react';

import { Typography, TypographyProps } from '@mui/material';
import _ from 'es-toolkit/compat';

import { Tooltip } from 'src/components/common';
import { SxProp } from 'src/types/mui';

export const OverflowTooltip: React.FC<React.PropsWithChildren<TypographyProps>> = ({
  children,
  ...typographyProps
}) => {
  const [isOverflow, setIsOverflow] = React.useState(false);
  const textElementRef = React.useRef<HTMLSpanElement>(null);

  const checkOverflow = () => {
    if (textElementRef.current) {
      const clientWidth = textElementRef.current.getBoundingClientRect().width;

      textElementRef.current.style.overflow = 'visible';
      const contentWidth = textElementRef.current.getBoundingClientRect().width;
      textElementRef.current.style.overflow = 'hidden';

      setIsOverflow(contentWidth > clientWidth);
    }
  };

  React.useEffect(() => {
    checkOverflow();
    window.addEventListener('resize', checkOverflow);

    return () => window.removeEventListener('resize', checkOverflow);
  }, []);

  return (
    <Tooltip title={children} disableHoverListener={!isOverflow}>
      <Typography
        {...typographyProps}
        ref={textElementRef}
        sx={_.merge({}, typographyProps.sx, typographyStyles)}
      >
        {children}
      </Typography>
    </Tooltip>
  );
};

const typographyStyles: SxProp = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
};
